import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { map, compact, includes, toLower, words, find } from 'lodash'

import Table from 'UI/Table'
import VcenterSubMenu from 'FoundationalComponents/AssetSubMenus/Vcenter'
import { ClusterReportFilters as Filters, filteredData } from './Filters';
import AssetNameWithLabel from 'FoundationalComponents/AssetNameWithLabel'

const booleanThFilter = ({ filter, changeFilters, filterName, filters }) => (
  <select onChange={event => changeFilters({ ...filters, [filterName]: (event.target.value === 'all' ? 'all' : event.target.value === 'true') })} style={{ width: "100%" }}>
    <option value="all" selected={'all'}>Show All</option>
    {map([{ label: 'Enabled', value: true }, { label: 'Disabled', value: false }], status => (
      <option value={status.value} selected={filter && filter.value === status.value}>{status.label}</option>
    ))}
  </select>
)

const VcenterAssetReportClusters = ({ clusters, locations }) => {
  const filterOptions = { locations: map(compact(locations), ({ id, name }) => ({ label: name, value: id })) }
  const [filters, changeFilters] = useState({
    locations: 'all',
    haEnabled: 'all',
    admissionControlEnabled: 'all',
    drsEnabled: 'all'
  })

  const columns = [
    { Header: 'Name', accessor: 'name', width: 300, Cell: ({ value, original }) => (<AssetNameWithLabel name={value} label={original.asset_label} />) },
    {
      Header: 'Location',
      id: 'location_name',
      width: 230,
      type: 'list',
      sortMethod: (a, b) => {
        const location_a = find(a, ['label', 'Location'])
        const location_b = find(b, ['label', 'Location'])

        return (location_a.value > location_b.value ? 1 : -1)
      },
      accessor: (data) => ([
        { label: 'Location', value: data.location_name },
        { label: 'vCenter', value: <VcenterSubMenu vcenter={data.vcenter} /> }
      ])
    },
    { Header: 'Hosts', accessor: 'hosts', type: 'number', width: 80 },
    { Header: 'Host CPU', accessor: 'host_num_cpu', type: 'number', width: 120 },
    { Header: 'Host CPU Sockets', accessor: 'host_cpu_sockets', type: 'number', width: 120 },
    { Header: 'Host Memory', accessor: 'host_memory_total_gb', type: 'humanizeGB', width: 120 },
    { Header: 'Running VMs', accessor: 'running_vms', type: 'number' },
    { Header: 'Admission Control Enabled', accessor: 'admission_control_enabled', type: 'boolean', Filter: ({ filter, onChange }) => booleanThFilter({ filter, changeFilters, filters, filterName: 'admissionControlEnabled' }) },
    { Header: 'HA Enabled', accessor: 'ha_enabled', type: 'boolean', Filter: ({ filter, onChange }) => booleanThFilter({ filter, changeFilters, filters, filterName: 'haEnabled' }) },
    { Header: 'DRS Enabled', accessor: 'drs_enabled', type: 'boolean', Filter: ({ filter, onChange }) => booleanThFilter({ filter, changeFilters, filters, filterName: 'drsEnabled' }) },
    { Header: 'DRS Behavior', accessor: 'drs_behavior', Cell: ({ value }) => words(value).join(" ") }
  ]

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, filterOptions }} />

      <Table {...{
        data:  filteredData({ clusters, filters }) ,
        columns:  columns,
        tableProps: {
          minRows:  0,
          filterable: true,
          defaultSorted: [{ id: 'vcenter', asc: true }]
        }
      }}/>
    </Fragment>
  )
}

export default VcenterAssetReportClusters
